import React from 'react';
import { CreditCardIcon, ZapIcon, SmileIcon } from 'lucide-react';
export function StepsSection() {
  const steps = [{
    icon: CreditCardIcon,
    title: 'Pay Normally',
    description: 'Use your linked card at any participating local business',
    color: 'bg-[#A020F0]',
    number: '1'
  }, {
    icon: ZapIcon,
    title: 'Earn Automatically',
    description: 'Points add up without scanning or checking in',
    color: 'bg-[#A020F0]',
    number: '2'
  }, {
    icon: SmileIcon,
    title: 'Enjoy Rewards',
    description: 'Redeem perks from your favorite local spots',
    color: 'bg-[#A020F0]',
    number: '3'
  }];
  return <section id="how-it-works" className="py-16 bg-[#f8f5ff]" data-id="element-438">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-439">
        <div className="text-center mb-12" data-id="element-440">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-441">How It Works</h2>
          <div className="h-1 w-20 bg-[#FFDE59] mx-auto" data-id="element-442"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-443">
          {steps.map((step, index) => <div key={index} className="relative bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-200 text-center" data-id="element-444">
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-[#FFDE59] w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold" data-id="element-445">
                {step.number}
              </div>
              <div className="mt-4" data-id="element-446">
                <div className={`${step.color} w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5`} data-id="element-447">
                  <step.icon className="h-8 w-8 text-white" data-id="element-448" />
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-449">{step.title}</h3>
                <p className="text-gray-600 text-sm" data-id="element-450">{step.description}</p>
              </div>
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-451">
          <p className="inline-block bg-[#f9f5ff] text-[#A020F0] px-4 py-2 rounded-full text-sm font-medium" data-id="element-452">
            No QR codes. No punch cards. Just effortless perks.
          </p>
        </div>
      </div>
    </section>;
}